module.exports = __webpack_public_path__ + "img/logop2.51bbc96a.png";